"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_SHARE = exports.DOWNLOAD_FLOW = undefined;

var _downloadFlowModal = require("../components/modals/download-flow-modal");

var _downloadFlowModal2 = _interopRequireDefault(_downloadFlowModal);

var _iconShareModal = require("../components/modals/icon-share-modal");

var _iconShareModal2 = _interopRequireDefault(_iconShareModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DOWNLOAD_FLOW = exports.DOWNLOAD_FLOW = _downloadFlowModal2.default;
var ICON_SHARE = exports.ICON_SHARE = _iconShareModal2.default;